const LoginParser = (data: any): any => {
  return {
    accessToken: data?.session?.accessToken?.tokenValue ?? '',
    refreshToken: data?.session?.refreshToken?.tokenValue ?? '',
    accessTokenExpiry: data?.session?.accessToken?.expiresIn ?? -1,
    refreshTokenExpiry: data?.session?.refreshToken?.expiresIn ?? -1,
    idToken: data?.session?.identifierToken ?? '',
    isVerified: true,
    lastLoginDate: '',
    jfsUserId: data?.jfsUserId ?? '',
  }
}

export { LoginParser }
